import React from 'react';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { SumAvgRender } from './SumAvgRender';

interface DateColumnsType {
  key: string;
  title: string | React.ReactNode;
  sortMetric?: string;
  currentSortMetric: string;
  currentSortValue: '' | 'desc' | 'asc';

  textContent?: string;
  dateType: string;
  onSortChage: (sortBy: SortByItemType) => void;
  width?: number | string;
  fixed?: 'left' | 'right';
  renderFunction?: (cvm: any) => React.ReactNode;
  sumInfo?: string | React.ReactNode;
  isNoDropdown?: boolean;
}

export const renderDateName = (
  value: string,
  dateType: string,
  sumInfo: string | React.ReactNode,
) => {
  const val = value?.toLocaleLowerCase();
  if (['sum', 'max', 'avg']?.includes(val)) {
    return SumAvgRender(value, sumInfo);
  }
  return showTimeByDateType(value, dateType);
};

export function DateColumns(params: DateColumnsType) {
  const {
    key,
    title,
    sortMetric,
    currentSortMetric,
    currentSortValue,
    textContent,
    dateType,
    onSortChage,
    width = 180,
    fixed,
    renderFunction = null,
    sumInfo,
    isNoDropdown,
  } = params;
  return {
    key,
    align: 'left',
    width,
    fixed,
    header: (
      <SortBy
        align={'left'}
        title={title}
        defaultKey={currentSortMetric}
        defaultValue={currentSortValue}
        list={[
          {
            key,
            sortMetric: sortMetric || key,
            text: textContent || title,
            title,
            ratioType: 0,
          },
        ]}
        onChange={onSortChage}
        isNoDropdown={isNoDropdown}
      />
    ),
    render: (cvm: any) => {
      return renderFunction ? renderFunction(cvm) : renderDateName(cvm?.[key], dateType, sumInfo);
    },
  };
}
